module.exports = __webpack_public_path__ + "static/yt_1@1x-9d67b587a44385a89c13fa2d99dff890.jpg";